import React, { useCallback, useState, useEffect } from "react";
import { Modal, Button, Typography, Form, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { CloseOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import { useDropzone } from "react-dropzone";
import DropzoneWrapper from "../../../components/util/Dropzone.style";
import { ReactComponent as CloudImg } from "../../../assets/img-cloud.svg";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import SwitchItem from "../../../components/forms/SwitchItem";
import { uploadEmergencyFile } from "../PatientsSlice";

const { Title, Text } = Typography;

const UploadEmergencyFile = (props) => {
  const { hide, visible, changeFailedRows, branchId } = props;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [values, setValues] = useState({});
  const loading = useSelector(
    (state) => state.pendingActions["patients/uploadEmergencyFile"]
  );

  useEffect(() => {
    const initialValues = {
      update_patient_main_contact: false,
      update_patient_address: false,
      update_patient_phones: false,
    };
    setValues(initialValues);
    setFiles([]);
    form.resetFields();
  }, [visible]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const newFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
          fileName: file.name,
        })
      );
      setFiles([...files, ...newFiles]);
    },
    [files]
  );
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    maxSize: process.env.REACT_APP_CONFIG === "matav" ? 10485760 : 10485760,
    accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const onDecline = () => {
    hide();
  };

  const onCancel = () => {
    hide();
  };

  const onValuesChange = (changedValues, allValues) => {
    setValues({ ...values, ...changedValues });
  };
  const onSubmit = async () => {
    const params = {
      branchId,
      file: files[0],
      ...values,
    };
    const action = await dispatch(uploadEmergencyFile(params));

    if (!action.error) {
      const failedRows = action?.payload?.FailedRows || [];
      const headers = action?.payload?.Headers || [];
      changeFailedRows(failedRows, headers);
      hide();
      setFiles([]);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      closable={false}
      maskClosable={false}
      open={visible}
      footer={null}
      onCancel={hide}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: "20px 100px",
          minWidth: "800px",
        },
      }}
      destroyOnClose={true}
    >
      <Form
        layout="vertical"
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        scrollToFirstError
        onValuesChange={onValuesChange}
        form={form}
      >
        <div>
          <div className="header" style={{ height: "40px" }}>
            <Button
              style={{ position: "absolute", left: 10, top: 10 }}
              className="closeBtn"
              type="text"
              shape="circle"
              icon={<CloseOutlined />}
              onClick={onDecline}
            />
          </div>
          <Title
            style={{
              fontSize: "30px",
              fontWeight: 500,
              lineHeight: 1.27,
              color: "rgba(0, 0, 0, 0.85)",
              margin: "13px 0 40px 0 ",
              textAlign: "center",
            }}
          >
            <FormattedMessage id={`app.actions.uploadBtlEmergencyTitle`} />
          </Title>

          <ChildrenAnimationWrapper>
            <Row>
              <Col key={1} span={9} style={{ padding: "0 20px" }}>
                <AnimationChildWrapper key={1} itemKey={1}>
                  <SwitchItem
                    name="update_patient_main_contact"
                    category="patient"
                  />
                </AnimationChildWrapper>
              </Col>
              <Col key={2} span={9} style={{ padding: "0 20px" }}>
                <AnimationChildWrapper key={3} itemKey={3}>
                  <SwitchItem
                    name="update_patient_address"
                    category="patient"
                  />
                </AnimationChildWrapper>
              </Col>
              <Col key={3} span={6} style={{ padding: "0 20px" }}>
                <AnimationChildWrapper key={2} itemKey={2}>
                  <SwitchItem name="update_patient_phones" category="patient" />
                </AnimationChildWrapper>
              </Col>
            </Row>
          </ChildrenAnimationWrapper>

          <DropzoneWrapper>
            <div
              {...getRootProps({ className: "outer" })}
              style={{ padding: "0 60px" }}
            >
              <CloudImg />
              <input {...getInputProps()} />
              <p className="title">
                {<FormattedMessage id="app.actions.dragAndDropEmergency" />}
              </p>
              <p className="subtitle">
                {<FormattedMessage id="app.actions.dragAndDropBtl2" />}
              </p>
              <p className="limit">
                {<FormattedMessage id="app.actions.onlyxlsx" />}
              </p>
            </div>
            <div className="filesContainer">
              {files.length > 0 ? (
                <Title level={3} style={{}}>
                  {<FormattedMessage id="app.titles.files" />}
                </Title>
              ) : null}
              {files.map((f) => (
                <Text key={f.path}>{f.name}</Text>
              ))}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "10px",
              }}
            >
              <div>
                <Button
                  disabled={files.length < 1 || loading}
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  size="large"
                >
                  {<FormattedMessage id="app.actions.uploadFiles" />}
                </Button>
                <Button
                  style={{ margin: "0 10px" }}
                  onClick={onCancel}
                  size="large"
                >
                  {<FormattedMessage id="app.actions.cancel" />}
                </Button>
              </div>
            </div>
          </DropzoneWrapper>
        </div>
      </Form>
    </Modal>
  );
};

export default UploadEmergencyFile;
